import { useMemo } from 'react';

import { moonshotCampaign } from 'app/src/components/Moonshot/moonshotCampaign';
import { splitScreenOnboardingCampaign } from 'app/src/components/SplitScreenOnboardingCampaign/splitScreenOnboardingCampaign';
import type { NewUserOnboardingCampaignQuery } from './NewUserOnboardingCampaignQuery.generated';

/**
 * This hook is used to select the proper new user onboarding campaign for the user,
 * who may have moonshot or split screen onboarding campaigns.
 *
 * @param campaigns - campaigns on the Member
 * @returns
 */
export const useSelectNewUserOnboardingCampaign = (
  campaigns: NonNullable<
    NewUserOnboardingCampaignQuery['member']
  >['campaigns'][number][],
) => {
  const userMoonshotCampaign = useMemo(
    () => campaigns.find((c) => moonshotCampaign.name === c.name),
    [campaigns],
  );

  const userSplitScreenOnboardingCampaign = useMemo(
    () => campaigns.find((c) => splitScreenOnboardingCampaign.name === c.name),
    [campaigns],
  );

  if (campaigns.length === 0) {
    return null;
  }

  // If the user is somehow in both campaigns, we want to prioritize the splitscreen onboarding campaign.
  // Having the splitscren onboarding campaign means the user has been bucketed in the cohort that receives Personal Productivity.
  // This implies this user will receive PP features after landing in product.
  return userSplitScreenOnboardingCampaign ?? userMoonshotCampaign ?? null;
};
